import React from 'react';
import {Button, Media} from 'reactstrap';
import ReactTooltip from "react-tooltip";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {MdCreate, MdDelete, MdTouchApp, MdClose, MdEmail} from 'react-icons/md';
import localeHelpers from "../../helpers/LocaleHelper";

let commonStrings = new LocalizedStrings(common_strings);

const RewardTableRow = (props) => {

    function makeIcon() {
        return require(`assets/img/icons/rewards/${props.reward.icon}.svg`);
    }

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    localize();
    return (
        <tr>
            <th scope="row">
                <img
                    style={{marginRight: '0.5rem'}}
                    width={24}
                    height={24}
                    onClick={e => props.assignReward(e, props.reward)}
                    alt=""
                    src={makeIcon()}
                />
            </th>
            <td>
                <div className="align-items-left ml-0">
                    <small>
                        <div onClick={e => props.assignReward(e, props.reward)}>
                            <h4 className="text-white">{props.reward.title}</h4>
                        </div>
                    </small>
                </div>

            </td>
            <td className="text-right align-content-end">
                <ReactTooltip/>
                <div>
                    {props.studentId && !(props.studentRewards.some(sr => sr.id === props.reward.id)) &&
                    <Button
                        className="btn-icon ct-example-tooltip-static"
                        color="success"
                        data-type="success"
                        data-tip={commonStrings.assign_reward}
                        onClick={e => props.assignReward(e, props.reward)}>
                        <MdTouchApp/>
                    </Button>
                    }

                    {props.studentId && props.studentRewards.some(sr => sr.id === props.reward.id) &&
                    <Button
                        className="btn-icon ct-example-tooltip-static"
                        color="danger"
                        data-type="success"
                        data-tip={commonStrings.unassign_reward}
                        onClick={e => props.unassignReward(e, props.reward)}>
                        <MdClose/>
                    </Button>
                    }

                    {!props.studentId &&
                    <Button
                        className="btn-icon ct-example-tooltip-static"
                        color="warning"
                        data-type="error"
                        data-tip={commonStrings.delete}
                        onClick={e => props.deleteReward(e, props.reward)}>
                        <MdDelete/>
                    </Button>
                    }
                    <Button
                        color="secondary"
                        data-type="info"
                        data-tip={commonStrings.edit}
                        onClick={e => props.editReward(e, props.reward)}>
                        <MdCreate/>
                    </Button>

                </div>
            </td>
        </tr>
    )
};

export default RewardTableRow;